<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="scanner-content">
  @if (errorMessage()) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <p>{{ errorMessage() }}</p>
    </div>
  } @else {
    @if (showScanner()) {
      <div class="scanner-wrapper">
        <zxing-scanner
          [formats]="data.allowedFormats"
          [device]="currentDevice()"
          (camerasFound)="onCamerasFound($event)"
          (scanSuccess)="onCodeResult($event)"
          (permissionResponse)="onPermissionResponse($event)"
          (scanError)="onScanError($event)"
          (autostarted)="forceSetCurrentDevice()"
        ></zxing-scanner>
        @if (availableDevices().length > 1) {
          <button type="button" class="camera-switch-button" (click)="switchCamera()" [title]="translateService.instant('liveforms-editor.common.buttons.switch-camera')">
            <mat-icon>cameraswitch</mat-icon>
          </button>
        }
      </div>
    } @else if (scannedBarcode()) {
      <div class="barcode-preview">
        <div class="preview-label">{{ translateService.instant('liveforms-editor.barcode-item.scanner.result') }}</div>
        <div class="preview-value">{{ scannedBarcode() }}</div>
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (scannedBarcode()) {
    <button mat-stroked-button (click)="retake()">
      <mat-icon>refresh</mat-icon>
      {{ translateService.instant('liveforms-editor.barcode-item.scanner.retake') }}
    </button>
    <button mat-raised-button color="primary" (click)="confirm()">
      <mat-icon>check</mat-icon>
      {{ translateService.instant('liveforms-editor.barcode-item.scanner.use-barcode') }}
    </button>
  }

  <button mat-button (click)="cancel()">
    {{ translateService.instant('liveforms-editor.barcode-item.scanner.cancel') }}
  </button>
</mat-dialog-actions>
